import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-170">
      {label && <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-171">
          {label}
        </label>}
      <input className={`block w-full px-3 py-2 bg-white border border-gray-300 rounded-md text-sm shadow-sm placeholder-gray-400
        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-50 disabled:text-gray-500 ${className}`} {...props} data-id="element-172" />
      {error && <p className="mt-1 text-xs text-red-600" data-id="element-173">{error}</p>}
    </div>;
}